import * as React from 'react'

import { Checkbox } from '../checkbox/Checkbox'
import { Label } from '../label/Label'
import { useDataTable } from './DataTableContext'

export const DataTableSelectAllRowsCheckbox = ({
  label = 'All rows selection'
}: {
  label?: string
}) => {
  const {
    getIsAllPageRowsSelected,
    getIsSomePageRowsSelected,
    toggleAllPageRowsSelected,
    tableId
  } = useDataTable()

  const getCheckedState = () => {
    if (getIsSomePageRowsSelected()) return 'indeterminate'
    if (getIsAllPageRowsSelected()) return true
    return false
  }

  const updateCheckedState = () => {
    if (getIsSomePageRowsSelected()) {
      return toggleAllPageRowsSelected(false)
    }
    return toggleAllPageRowsSelected(!getIsAllPageRowsSelected())
  }

  return (
    <>
      <label htmlFor={`${tableId}_all_rows_selection`} className="sr-only">
        {label}
      </label>
      <Checkbox
        size="lg"
        checked={getCheckedState()}
        onCheckedChange={updateCheckedState}
        name={`${tableId}_allRowsSelection`}
      />
    </>
  )
}
